module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-standside-2000.45d2fefb.svg";